import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { createChat, updateChat } from "../../store/actions/chats";
import SystemMessages from "../SystemMessages";
import InfiniteScroll from "react-infinite-scroller";
import { List } from "antd";

import ChatItem from "./ChatItem";

import "./ChatList.scss";

class ChatList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: null,
      optionBoxOpenId: false,
      optionBoxDirection: "bottom",
      unread: {},
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  removeReactivity(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  onCardClick(chat) {
    this.props.onCardClick(chat, true);
  }

  onLeave() {
    if (this.state.optionBoxOpenId) {
      this.setState({
        optionBoxOpenId: null,
      });

      document.removeEventListener("click", this.handleClickOutside);
    }
  }

  toggleOptionsBox(event, chat) {
    event?.stopPropagation();

    this.setState({
      optionBoxOpenId: chat?.id,
      optionBoxDirection:
        event?.target?.getBoundingClientRect().y > window.innerHeight / 2
          ? "top"
          : "bottom",
    });

    document.addEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.optionBoxRef && !this.optionBoxRef.contains(event.target)) {
      event.stopPropagation();
      this.setState(
        {
          optionBoxOpenId: false,
        },
        document.removeEventListener("click", this.handleClickOutside)
      );
    }
  }

  onOptionDivClick(e) {
    e.stopPropagation();
  }

  setOptionBoxRef(node) {
    this.optionBoxRef = node;
  }

  isChatUnread(item) {
    return item.newMessages;
  }

  emitEvent = (eventName, eventData) => {
    if (window.hasOwnProperty("Social")) {
      window.Social.emit(eventName, eventData);

      this.setState(
        {
          optionBoxOpenId: null,
        },
        document.removeEventListener("click", this.handleClickOutside)
      );
    }
  };

  archiveChat = (e, chat) => {
    this.props.archiveChat(e, chat);

    this.setState(
      {
        optionBoxOpenId: null,
      },
      document.removeEventListener("click", this.handleClickOutside)
    );
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { hasErrors, flags, mentions } = this.props;

    return (
      <div className="chat-list-container">
        {!hasErrors && (
          <InfiniteScroll
            loadMore={this.props.handleInfiniteOnLoad}
            hasMore={this.props.hasMoreChats}
            initialLoad={false}
            useWindow={false}
          >
            <List
              id={this.state.id}
              className="chat-list"
              locale={{ emptyText: "" }}
              dataSource={this.props.list}
              loading={this.props.loading}
              renderItem={(item) => (
                <List.Item
                  onMouseLeave={() => this.onLeave()}
                  onClick={() => this.onCardClick(item)}
                >
                  <ChatItem
                    item={item}
                    flags={flags}
                    mentions={mentions}
                    formatMessage={formatMessage}
                    isChatUnread={this.isChatUnread.bind(this)}
                    optionBoxOpenId={this.state.optionBoxOpenId}
                    optionBoxDirection={this.state.optionBoxDirection}
                    setOptionBoxRef={this.setOptionBoxRef.bind(this)}
                    toggleOptionsBox={this.toggleOptionsBox.bind(this)}
                    archiveChat={this.archiveChat.bind(this)}
                    emitEvent={this.emitEvent.bind(this)}
                    onOptionDivClick={this.onOptionDivClick}
                  />
                </List.Item>
              )}
            />
          </InfiniteScroll>
        )}

        <SystemMessages
          listLength={this.props.list.length}
          loading={this.props.loading}
          hasErrors={this.props.hasErrors}
          isSearching={this.props.isSearching}
          resetFilters={this.props.resetFilters}
          createChat={this.props.createChat}
          reconnect={this.props.reconnect}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ Chats }) => {
  return {
    chats: Chats.chats,
  };
};

const mapDispatchToProps = (dispatch) => ({
  createChat: (chat) => dispatch(createChat(chat)),
  updateChat: (chat) => dispatch(updateChat(chat)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ChatList));
